module.exports = __webpack_public_path__ + "static/media/card.8fc8ba4b.svg";